module.exports = __webpack_public_path__ + "img/4-8.fbde9efe.png";